/** Public transport URL only. Web Service credentials belong exclusively to the gateway. */
export function getAmapProxyBaseUrl(): string {
  if (typeof window !== "undefined" && window.location.protocol === "file:" && window.geelyDemo?.requestAmap) return "electron-amap";
  const configured = import.meta.env.VITE_AMAP_PROXY_URL?.trim();
  if (configured) return configured.replace(/\/+$/, "");
  return typeof window !== "undefined" && /^https?:$/.test(window.location.protocol) ? "/amap" : "";
}

export async function fetchAmapProxy(proxyBase: string, path: string, params: URLSearchParams) {
  if (!proxyBase || !path.startsWith("/v3/")) throw new Error("amap-proxy-unavailable");
  const safeParams = new URLSearchParams(params);
  safeParams.delete("key");
  if (proxyBase === "electron-amap") {
    const bridge = window.geelyDemo?.requestAmap;
    if (!bridge) throw new Error("amap-proxy-unavailable");
    const result = await bridge({ path, query: safeParams.toString() });
    return new Response(result.body, { status: result.status, headers: { "Content-Type": "application/json" } });
  }
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 10000);
  try {
    const response = await fetch(`${proxyBase.replace(/\/+$/, "")}${path}?${safeParams}`, {
      signal: controller.signal,
      credentials: "same-origin"
    });
    // Consume the body within the timeout, not just the response headers.
    const body = await response.text();
    return new Response(body, { status: response.status, headers: response.headers });
  } finally {
    clearTimeout(timeout);
  }
}
